export enum EApplicationStatus {
    AWAITING_RS_RECOMMENDATION = 100,
    AWAITING_SHEPHERDS_REVIEW = 101,
    NOT_RECOMMENDED_BY_RS = 102,
    PENDING_INTERVIEW = 103,
    PENDING_FINAL_DECISION = 104,
    APPROVED = 105,
    DENIED_BY_LU_SHEPHERD = 106,
    WITHDRAWN_BY_APPLICANT = 108,
    EXPIRED = 109,
    PENDING_OFFER = 110,
    NOT_HIRED = 112,
    HIRED = 113,
    TERMINATED = 114,
    STEPPED_DOWN = 115,
    OFFER_EXPIRED = 116,
    IN_ELIGIBLE_POOL = 117,
    WAIT_LISTED = 118
}

export function StatusCodeToString(status: EApplicationStatus): string {
    return ({
        [EApplicationStatus.AWAITING_RS_RECOMMENDATION]: "Awaiting RS Recommendation",
        [EApplicationStatus.AWAITING_SHEPHERDS_REVIEW]: "Awaiting Shepherds Review",
        [EApplicationStatus.NOT_RECOMMENDED_BY_RS]: "Not Recommended by RS",
        [EApplicationStatus.PENDING_INTERVIEW]: "Interview Requested",
        [EApplicationStatus.PENDING_FINAL_DECISION]: "Awaiting Shepherds Approval",
        [EApplicationStatus.APPROVED]: "Approved",
        [EApplicationStatus.DENIED_BY_LU_SHEPHERD]: "Denied by LU Shepherd",
        [EApplicationStatus.WITHDRAWN_BY_APPLICANT]: "Withdrawn by Applicant",
        [EApplicationStatus.EXPIRED]: "Application Expired",
        [EApplicationStatus.PENDING_OFFER]: "Pending Offer",
        [EApplicationStatus.NOT_HIRED]: "Not Hired",
        [EApplicationStatus.HIRED]: "Hired",
        [EApplicationStatus.TERMINATED]: "Terminated",
        [EApplicationStatus.STEPPED_DOWN]: "Stepped Down",
        [EApplicationStatus.OFFER_EXPIRED]: "Offer Expired",
        [EApplicationStatus.IN_ELIGIBLE_POOL]: "In Eligible Pool",
        [EApplicationStatus.WAIT_LISTED]: "Wait Listed"
    })[status];
}
